import React, { useState } from "react";
import { Text, Button } from "@bookingcom/bui-react";

import { useI18n, t } from "@bookingcom/lingojs-react";
import useModalDialog from "../../../hooks/useModalDialog";

import { UIPOSMismatch } from "@flights/types";

import useTranslatedCountryNames from "../../../hooks/useTranslatedCountryNames";
import Frame from "../Frame";

interface Props {
  goToSearch: () => void;
  POSMismatch: UIPOSMismatch;
}
const POSMisMatch: React.FunctionComponent<Props> = (props: Props) => {
  const Modal = useModalDialog();
  const [isModalOpen, setModalOpen] = useState(true);
  const i18n = useI18n();
  const { goToSearch, POSMismatch } = props;
  const { getCountryName, getCountryNameFrom, getCountryNameArticle, getCountryNameIn } = useTranslatedCountryNames();

  const title = i18n.trans(
    t("flights_meta_different_pos_detected_header", {
      variables: {
        country_name_from: getCountryNameFrom(POSMismatch.detectedPointOfSale),
        name_article: getCountryNameArticle(POSMismatch.detectedPointOfSale),
        country_name: getCountryName(POSMismatch.detectedPointOfSale)
      }
    })
  );

  return (
    <Modal
      ariaLabel={title}
      active={isModalOpen}
      onCloseTrigger={() => {
        setModalOpen(false);
        goToSearch();
      }}
      size={"large"}
      title={title}
    >
      <Frame mt={3} mb={8}>
        <Text variant="body_1" attributes={{ tabIndex: 0 }}>
          {i18n.trans(
            t("flights_meta_different_pos_detected_sub_head", {
              variables: {
                country_name_in: getCountryNameIn(POSMismatch.detectedPointOfSale),
                name_article: getCountryNameArticle(POSMismatch.detectedPointOfSale),
                country_name: getCountryName(POSMismatch.detectedPointOfSale)
              }
            })
          )}
        </Text>
      </Frame>
      <Button variant="primary" onClick={goToSearch}>
        {i18n.trans(t("flights_meta_different_pos_detected_cta", {}))}
      </Button>
    </Modal>
  );
};
export default POSMisMatch;
